module.exports = __webpack_public_path__ + "static/media/zoo_2.a10d48a9.jpg";